import React from 'react';
import { GlobalComponentConfig } from './GlobalComponentConfig';
import { SupportedDataSources } from '@r-and-a-shared-ui/core-data-mapping';

export const ComponentConfigContext = React.createContext({
  cmsBasedDataMapping: {
    [SupportedDataSources.KontentAi]: GlobalComponentConfig.dataConfig,
  },
  CURRENT_CMS: SupportedDataSources.KontentAi,
});
